import SearchTypeFilters from 'components/SearchTypeFilters/SearchTypeFiltersPresentation'

export default SearchTypeFilters
